/**
 * The call's match player is the async lesson player (decision 103), with
 * its own bar, speed and chapters. What is the call's own: the chip on the
 * other side when someone moves the video (decision 74). Anyone moves it;
 * there is no driver and no lock (100). Pure, so tested.
 */

/** "Ana moved to 4:12" stays this long on the other side. */
export const MOVED_CHIP_MS = 2500;

/** "4:12". */
export function clock(seconds: number): string {
  const t = Math.max(0, Math.floor(seconds));
  return `${Math.floor(t / 60)}:${(t % 60).toString().padStart(2, '0')}`;
}

/** The chip on the other side when someone moves the video (decision 74). */
export function movedChip(first: string, time: number): string {
  return `${first} moved to ${clock(time)}`;
}
